import LayoutComponent from '@/ui-components/layouts/Layout'
import useLayout from '@/hooks/useLayout'
import Loading from '@/component/Loading/Loading'

type LayoutProps = { children: React.ReactNode; loading?: boolean }

const Layout = ({ children, loading }: LayoutProps) => {
  const {
    logo,
    username,
    balance,
    isMaskedBalance,
    onLogoClick,
    onLanguageChange,
    currentLang,
    languages,
    navItems,
    activePath,
    onNavClick,
    isUpdating,
    onRefreshClick,
    cooldown,
    isDisabled,
  } = useLayout()

  return (
    <LayoutComponent
      logo={logo}
      username={username}
      balance={balance}
      isMaskedBalance={isMaskedBalance}
      onLogoClick={onLogoClick}
      onLanguageChange={onLanguageChange}
      currentLang={currentLang}
      languages={languages}
      navItems={navItems}
      activePath={activePath}
      onNavClick={onNavClick}
      isUpdating={isUpdating}
      onRefreshClick={onRefreshClick}
      cooldown={cooldown}
      isDisabled={isDisabled}
    >
      <Loading loading={loading}>{children}</Loading>
    </LayoutComponent>
  )
}

export default Layout
